import {AdBannerEventType} from '@core-client/ads/banner/AdBannerEventType';
import {log} from '../util/BannerCommon';
import type {IBannerViewOptions} from '../view/BannerView';

import type {IBannerHookSettings} from './BaseBannerHook';
import {BannerWithOptionsHook} from './BannerWithOptionsHook';
import type {IBannerJson} from './IBannerJson';

export class FeedBannerHook extends BannerWithOptionsHook {
    constructor(settings: IBannerHookSettings<IBannerJson>) {
        log('FeedBannerHook init');
        super(settings);
    }

    override activate() {
        super.activate();
        this.element.classList.add('__hidden');
        this.listenAdLoaded();
    }

    override deactivate() {
        this.unlistenAdLoaded();
        super.deactivate();
    }

    override getAdLoadEventList() {
        return [AdBannerEventType.mrgRenderInit, AdBannerEventType.rbAdInfo, AdBannerEventType.yaspEvent];
    }

    protected override handleAdLoaded() {
        this.element.classList.remove('__hidden');
        super.handleAdLoaded();
    }

    prepareBannerViewOptions(options: IBannerViewOptions): IBannerViewOptions {
        options.externalShow = true;
        return options;
    }
}
